import React from 'react';
import { View } from 'react-native';

import { ActionDock, PrimaryButton, SecondaryButton } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';

// Dock for each step: edit (cancel/save or review), confirmed-count review, and after saving.
const RestockCorrectionDock = ({
	savedConfirmedCorrection,
	inventoryConfirmed,
	reviewingConfirmedCorrection,
	saving,
	reloading,
	saveDisabled,
	onSave,
	onReview,
	onBackToEdit,
	onCancel,
	onReviewStockLevels,
	onKeepDeliveryCorrectionOnly,
}) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);

	if (savedConfirmedCorrection) {
		const canReviewStock = Boolean(savedConfirmedCorrection.availability?.allowed);
		return (
			<ActionDock
				action={canReviewStock
					? { label: 'Review stock levels', onPress: onReviewStockLevels }
					: { label: 'Keep delivery correction only', onPress: onKeepDeliveryCorrectionOnly }}
			>
				{canReviewStock && (
					<SecondaryButton
						label="Keep delivery correction only"
						onPress={onKeepDeliveryCorrectionOnly}
					/>
				)}
			</ActionDock>
		);
	}
	if (inventoryConfirmed && reviewingConfirmedCorrection) {
		return (
			<ActionDock
				action={{
					label: 'Confirm delivered quantities',
					onPress: onSave,
					loading: saving,
					disabled: saveDisabled,
				}}
			>
				<View style={styles.dockRow}>
					<SecondaryButton
						style={styles.dockButton}
						label="Back to edit"
						onPress={onBackToEdit}
						disabled={saving || reloading}
					/>
					<SecondaryButton
						style={styles.dockButton}
						label="Cancel"
						onPress={onCancel}
						disabled={saving || reloading}
					/>
				</View>
			</ActionDock>
		);
	}
	return (
		<ActionDock>
			<View style={styles.dockRow}>
				<SecondaryButton
					style={styles.dockCancel}
					label="Cancel"
					onPress={onCancel}
					disabled={saving || reloading}
				/>
				<PrimaryButton
					style={styles.dockButton}
					size="compact"
					label={inventoryConfirmed ? 'Review Missing and Extra' : 'Save delivered correction'}
					onPress={inventoryConfirmed ? onReview : onSave}
					loading={inventoryConfirmed ? false : saving}
					disabled={saveDisabled}
				/>
			</View>
		</ActionDock>
	);
};

export default RestockCorrectionDock;
